import './Markers.css';

export function ContainerSvgData(width: number, height: number, fillColor: string) {
  return `
    <svg class="idata-target-marker" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1680 1680">
   <g fill=${fillColor} style="transform: none;">
      <g>
         <path id="p1HnuOwAmT" d="M200 840 l0 -340 74 0 74 0 32 40 32 40 428 0 428 0 32 -40 32 -40 74 0 74 0 0 340 0 340 -640 0 -640 0 0 -340z m230 40 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z m150 0 l0 -150 -40 0 -40 0 0 150 0 150 40 0 40 0 0 -150z"></path>
      </g>
   </g>
</svg>`;
}
